
import { createClient } from '@supabase/supabase-js'
const supabaseUrl = 'https://enkihprmnurgqgqluwvo.supabase.co'
const supabaseKey = 'sb_publishable_qgq0EFSyjjurv32aXnufFg_iCe2QGEh'


export const supabase = createClient(supabaseUrl, supabaseKey)